import React, { Fragment, useContext, useState, useEffect } from "react";
import axios from "axios";

import { EligibilityContext } from "../../contexts/EligibilityContext";

import MedicationField from "./MedicationField";
import Icon from "../Icon";
import Loading from "../Loading";

const Medications = () => {
  const context = useContext(EligibilityContext);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");

  const addMed = (event) => {
    event.preventDefault();
    context.actions.setMedications((prevState) => [...prevState, ""]);
  };

  const handleNoMedication = (event) => {
    event.preventDefault();
    context.actions.setModalOpen(true);
    context.actions.setStep(9);
  };

  const filterMedications = (array) => {
    // remove empty strings
    const filteredMeds = array.filter(Boolean);

    const jsonObject = filteredMeds.map(JSON.stringify);
    const uniqueSet = new Set(jsonObject);
    const uniqueArray = Array.from(uniqueSet).map(JSON.parse);

    return uniqueArray;
  };

  const completeMeds = (event) => {
    event.preventDefault();

    let filteredMeds = filterMedications(context.state.medications);

    if (filteredMeds.length === 0) {
      // show and error if no medications have been selected
      setError("Please select at least one medication or service");
    } else {
      context.actions.setMedications(filteredMeds);

      if (window.dataLayer) {
        window.dataLayer.push({
          event: "Wizard Search",
          "Wizard Role": context.state.role,
          "Wizard Disease": (context.state.diseaseFund || {}).name,
          "Wizard Medication": context.state.medications
            .map((m) => m.DrugName)
            .join(", "),
        });
      }

      // advance to the next step if medications have been selected
      // If the fund is open, go to the eligibility screen, otherwise
      // display the closed screen and resources
      if (context.state.diseaseFund.fundStatus === "open") {
        return context.actions.setStep(3);
      } else {
        const supportProgramsUrl = `/wp-json/salesforce/v1/funds/${context.state.diseaseFund.fundId}/supportprograms`;
        setChecking(true);
        axios
          .get(supportProgramsUrl)
          .then((response) => {
            context.actions.setSupportPrograms(response.data.Partners || []);
            context.actions.setStep(
              context.state.diseaseFund.fundStatus === "open to wait list only"
                ? 7
                : 6
            );
          })
          .catch(() => {
            context.actions.renderError();
          });
      }
    }
  };

  return (
    <Fragment>
      <p className="f-h3">
        Eligibility Pre-screen for {context.state.diseaseFund.name}
      </p>
      <form className="u-form">
        <fieldset>
          <legend className="u-mb2">
            Select medication(s) or type of service
            {error && <span data-validate="error"> {error}</span>}
          </legend>

          {context.state.medications.map((medication, i) => (
            <MedicationField
              className="u-mb4"
              key={i}
              medication={medication}
              count={i + 1}
              setError={setError}
            />
          ))}

          {!context.state.diseaseFund.medications && (
            <Loading
              className="Loading--small"
              label="Loading medications"
            />
          )}

          <div className="u-mt3 u-mb3">
            <button
              type="button"
              className="btn--transparentIcon"
              onClick={(event) => addMed(event)}
            >
              <Icon name="plus" /> Add Medication or Service
            </button>
          </div>

          <div
            style={{
              alignItems: "flex-end",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <button
              type="button"
              className="btn"
              disabled={checking}
              onClick={(event) => completeMeds(event)}
            >
              {checking && <Fragment>Checking Eligibility...</Fragment>}
              {!checking && <Fragment>Next</Fragment>}
            </button>
            <button
              onClick={handleNoMedication}
              type="button"
              className="btn-reset f-link"
            >
              Can't find the right medication or service?
            </button>
          </div>
        </fieldset>
      </form>
    </Fragment>
  );
};

export default Medications;
